function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { WhiteboardTool } from './WhiteboardTool';
export class LaserPointerTool extends WhiteboardTool {
  constructor(enableToolEvent, modelGetter, shadowEmitter, scope) {
    super(enableToolEvent, modelGetter, shadowEmitter, scope);
    _defineProperty(this, "elementModel", null);
    _defineProperty(this, "pointCount", 0);
    _defineProperty(this, "showLiveCursor", true);
    this.tool.minDistance = 5;
  }
  onMouseDown(_event) {
    this.pointCount = 0;
    if (this.elementModel) {
      this.elementModel.dispose();
    }
    this.elementModel = null;
    this.modelGetter().then(model => {
      if (model) {
        this.elementModel = model.createLaserPointer();
      }
    });
  }
  onMouseDrag(event) {
    if (this.pointCount > 1024) {
      return;
    }
    const MIN_DISTANCE = 4;
    if (this.elementModel) {
      const len = this.elementModel.points.length;
      let last = {
        x: 0,
        y: 0
      };
      if (len >= 2) {
        last = {
          x: this.elementModel.points[len - 2],
          y: this.elementModel.points[len - 1]
        };
      }
      const dist = Math.max(Math.abs(last.x - event.point.x), Math.abs(last.y - event.point.y));
      if (dist >= MIN_DISTANCE) {
        this.pointCount += 1;
        this.elementModel.appendPoints([Math.round(event.point.x), Math.round(event.point.y)]);
      }
    }
  }
  onMouseUp(_event) {
    if (this.elementModel) {
      this.elementModel.beginRemoveAnimate();
    }
  }
}